import { Maybe } from "graphql/jsutils/Maybe";

import { Speaker } from "@/states/call/speakers";
import {
  CategorizedSpeakers,
  DeductMainSpeakersArgs,
} from "./participants.helpers.decl";

export function deductMainSpeakers({ type, from, to }: DeductMainSpeakersArgs) {
  if (type === "outbound") {
    return { mainAgentId: from.agentId, mainExternalNumber: to.number };
  }

  return { mainAgentId: to.agentId, mainExternalNumber: from.number };
}

export function categorizeSpeakers(
  speakers: Map<number, Speaker>,
  mainAgentId: Maybe<string>,
  mainExternalNumber: string
) {
  return [...speakers.keys()].reduce<CategorizedSpeakers>(
    (acc, channel) => {
      const speaker = speakers.get(channel);

      if (!speaker) {
        return acc;
      }

      const { agentID, number } = speaker;

      switch (true) {
        case agentID && agentID === mainAgentId:
          acc.mainAgent = { ...speaker, channel };
          break;
        case !!agentID:
          acc.otherAgents.push({ ...speaker, channel });
          break;
        case number && number === mainExternalNumber:
          acc.externalUser = { ...speaker, channel };
          break;
        default:
          acc.otherUsers.push({ ...speaker, channel });
      }

      return acc;
    },
    {
      mainAgent: null,
      externalUser: null,
      otherAgents: [],
      otherUsers: [],
    }
  );
}
